"use strict";

function setfeet() {
    const infeet = document.getElementById("infeet");
    const inmetres = document.getElementById("inmetres");
    inmetres.value = Math.round(infeet.value * .3048 * 10) / 10;
    calcprop();
}

function setmetres() {
    const infeet = document.getElementById("infeet");
    const inmetres = document.getElementById("inmetres");
    infeet.value=Math.round(inmetres.value * 3.28084 * 10) / 10;
    calcprop();
}

function setkgs() {
    const inpounds = document.getElementById("inpounds");
    const inkgs = document.getElementById("inkgs");
    const intons = document.getElementById("intons");
    inpounds.value = Math.round(inkgs.value * 2.204623);
    intons.value=Math.round(inkgs.value / 1016.047 * 100) / 100;
    calcprop();
}

function settons() {
    const inpounds = document.getElementById("inpounds");
    const inkgs = document.getElementById("inkgs");
    const intons = document.getElementById("intons");
    inkgs.value=Math.round(intons.value * 1016.047 * 10) / 10;
    inpounds.value=Math.round(intons.value * 2240 * 100) / 100;
    calcprop();
}

function setpounds() {
    const inpounds = document.getElementById("inpounds");
    const inkgs = document.getElementById("inkgs");
    const intons = document.getElementById("intons");
    inkgs.value=Math.round(inpounds.value / 2.204623 * 10) / 10;
    intons.value=Math.round(inpounds.value / 2240 * 100) / 100;
    calcprop();
}

function calcprop() {

    const inpounds = document.getElementById("inpounds");
    const disppounds = inpounds.value;

    const sliderknots = document.getElementById("sliderknots");
    const infeet = document.getElementById("infeet");
    const slr = sliderknots.value/Math.sqrt(infeet.value);
    const neededpower = disppounds/Math.pow(10.665 / slr, 3);
    
    const sliderrpm = document.getElementById("sliderrpm");
    const sliderratio = document.getElementById("sliderratio");
    const srpm = sliderrpm.value/sliderratio.value;
    const slip = 1.4 / (Math.pow(sliderknots.value, 0.57)) + 1;

    const sliderhp = document.getElementById("sliderhp");
    const shp = sliderhp.value * 0.97;
    const hp = Math.pow(shp, .2);
    const ssrpm = Math.pow(srpm, .6);
    var dia = (hp/ssrpm) * 632.7;
    dia = Math.round(dia*10) / 10;
    const pitchtemp = Math.round(sliderknots.value * 101.3 / srpm * 12 * slip * 10) / 10;

    const hullspeed = Math.round(1.34 * Math.sqrt(infeet.value) * 10) / 10;
    const twoblade =  Math.round(dia * 1.05 * 10) / 10 + " x " + Math.round(pitchtemp * 1.01 * 10) / 10 + "  2 Blades S4 S6";

    const shpout = document.getElementById("shpout");
    shpout.innerHTML = Math.round(shp) + " Shaft Horse Power Available";

    const srpmout = document.getElementById("srpmout");
    srpmout.innerHTML = Math.round(srpm) + " Shaft RPM";

    const diaout = document.getElementById("diaout");
    diaout.innerHTML = dia + " x " + pitchtemp + "  3 Blades S5 S7";

    const slipout = document.getElementById("slipout");
    slipout.innerHTML = Math.round((slip - 1) * 100) + "% Prop Slip";
    
    const powerneededout = document.getElementById("powerneededout");
    powerneededout.innerHTML = Math.round(neededpower) + " Horse Power Needed to Reach " + sliderknots.value + " Knots";

    const hullspeedout = document.getElementById("hullspeedout");
    hullspeedout.innerHTML = hullspeed + " Knots Max Hull Speed";

    const slrout = document.getElementById("slrout");
    slrout.innerHTML = Math.round(slr * 100) / 100 + " Speed Length Ratio";
    
    const twobladeout = document.getElementById("twobladeout");
    twobladeout.innerHTML = twoblade;

    // const point7rule = document.getElementById("point7rule");
    // point7rule.innerHTML = dia + " x " + Math.round(dia * .7 * 10) / 10;

    const s1size = document.getElementById("s1size");
    s1size.innerHTML = dia + 1 + " x " + (pitchtemp + 1.5) + "  3 Blades S1 S2";

    const knotsout = document.getElementById("knotsout");
    if (sliderknots.value > hullspeed) {
        knotsout.style.color = "red";
    } else {
        knotsout.style.color = "green";
    };
    
    if (neededpower > shp) {
        powerneededout.style.color = "red";
    } else {
        powerneededout.style.color = "green";
    }
    
    if (slr > 1.5) {
      slrout.style.color = "red";
    } else {
      slrout.style.color = "green";
    }

    const speedcheck = document.getElementById("speedcheck");
    if (neededpower-.5 > shp) {
        speedcheck.innerHTML = "Decrease Speed";
        speedcheck.style.color = "red";
    } else {
        speedcheck.innerHTML = "Speed OK";
        speedcheck.style.color = "green";
    }

    if (neededpower+.5 < shp) {
        speedcheck.innerHTML = "Increase Speed";
        speedcheck.style.color = "red";
    }
}

calcprop();